import { render, staticRenderFns } from "./personalPromotion.vue?vue&type=template&id=9c6761ea&scoped=true"
import script from "./personalPromotion.vue?vue&type=script&lang=js"
export * from "./personalPromotion.vue?vue&type=script&lang=js"
import style0 from "./personalPromotion.vue?vue&type=style&index=0&id=9c6761ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6761ea",
  null
  
)

export default component.exports